var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingHeroTopCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 308,
    viewBox: "0 0 308 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 308,
    height: 308,
    rx: 154,
    fill: "#E9EFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingHeroTopCircle);
export default __webpack_public_path__ + "static/media/TrainingHeroTopCircle.af2abf49faae5206f893457ad1e958d3.svg";
export { ForwardRef as ReactComponent };